import { render, staticRenderFns } from "./TagField.vue?vue&type=template&id=6f7f0c1f&"
import script from "./TagField.vue?vue&type=script&lang=js&"
export * from "./TagField.vue?vue&type=script&lang=js&"
import style0 from "./TagField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports